/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';
import { LegendPosition, PieChartComponent, ScaleType } from '@swimlane/ngx-charts';

@Component({
    selector: 'dash-gis-custom-pie-chart',
    templateUrl: './custom-pie-chart.component.html',
    styleUrls: ['./custom-pie-chart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomPieChartComponent extends PieChartComponent implements OnChanges, AfterViewInit, OnDestroy {
    // inputs/outputs from BaseChartComponent
    @Input() results: any;
    @Input() view: [number, number];
    @Input() scheme: any = 'cool';
    @Input() schemeType = ScaleType.Ordinal;
    @Input() customColors: any;
    @Input() animations = true;

    // inputs/outputs from PieChartComponent
    @Input() labels = false;
    @Input() legend = false;
    @Input() legendTitle = 'Legend';
    @Input() legendPosition = LegendPosition.Right;
    @Input() explodeSlices = false;
    @Input() doughnut = false;
    @Input() arcWidth = 0.25;
    @Input() gradient: boolean;
    @Input() activeEntries: any[] = [];
    @Input() tooltipDisabled = false;
    @Input() labelFormatting: any;
    @Input() trimLabels = true;
    @Input() maxLabelLength = 10;
    @Input() tooltipText: any;
    @Output() dblclick = new EventEmitter();
    // optional margins
    @Input() margins: number[];
    @Output() select = new EventEmitter();
    @Output() activate: EventEmitter<any> = new EventEmitter();
    @Output() deactivate: EventEmitter<any> = new EventEmitter();

    @ContentChild('tooltipTemplate') tooltipTemplate: TemplateRef<any>;

    ngAfterViewInit(): void {
        super.ngAfterViewInit();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }
}
